// digitalFingerprint.min.js must be loaded as a classic script on the page; it sets window.secureAuth.
// Bundled ES modules cannot use the bare identifier `secureAuth` (ReferenceError); read it from the global object.
export function getFingerprint() {
    if (sessionStorage.getItem('deviceFingerprint')) {
        return sessionStorage.getItem('deviceFingerprint');
    }
    const secureAuth = typeof window !== 'undefined' ? window.secureAuth : undefined;
    if (!secureAuth?.fingerprint?.getAllResults) {
        return '';
    }
    try {
        const fingerprint = JSON.stringify(secureAuth.fingerprint.getAllResults());
        sessionStorage.setItem('deviceFingerprint', fingerprint);
        return fingerprint;
    } catch {
        return '';
    }
}
